export var PrintPublicationInfoField;
(function (PrintPublicationInfoField) {
  PrintPublicationInfoField["CITY"] = "city";
  PrintPublicationInfoField["EDITION"] = "editiontext";
  PrintPublicationInfoField["END_PAGE"] = "end";
  PrintPublicationInfoField["NON_CONSECUTIVE"] = "nonconsecutive";
  PrintPublicationInfoField["PUBLISHER"] = "publisher";
  PrintPublicationInfoField["SERIES"] = "series";
  PrintPublicationInfoField["START_PAGE"] = "start";
  PrintPublicationInfoField["STATE"] = "state";
  PrintPublicationInfoField["TITLE"] = "title";
  PrintPublicationInfoField["TOTAL_VOLUMES"] = "vols";
  PrintPublicationInfoField["VOLUME"] = "vol";
  PrintPublicationInfoField["YEAR"] = "year";
  PrintPublicationInfoField["SOURCE"] = "source";
  PrintPublicationInfoField["WELL_KNOWN"] = "wellknown";
})(PrintPublicationInfoField || (PrintPublicationInfoField = {}));
export var FederalPublicationInfoField;
(function (FederalPublicationInfoField) {
  FederalPublicationInfoField["START_PAGE"] = "start";
  FederalPublicationInfoField["VOLUME"] = "vol";
  FederalPublicationInfoField["SOURCE"] = "source";
  FederalPublicationInfoField["YEAR"] = "year";
  FederalPublicationInfoField["CONGRESS"] = "congress";
  FederalPublicationInfoField["PUBLISHER"] = "publisher";
})(FederalPublicationInfoField || (FederalPublicationInfoField = {}));
export var JournalPublicationInfoField;
(function (JournalPublicationInfoField) {
  JournalPublicationInfoField["END_PAGE"] = "end";
  JournalPublicationInfoField["NON_CONSECUTIVE"] = "nonconsecutive";
  JournalPublicationInfoField["RESTARTS"] = "restarts";
  JournalPublicationInfoField["SERIES"] = "series";
  JournalPublicationInfoField["START_PAGE"] = "start";
  JournalPublicationInfoField["TITLE"] = "title";
  JournalPublicationInfoField["VOLUME"] = "volume";
  JournalPublicationInfoField["DATE_ACCESSED"] = "date_accessed";
  JournalPublicationInfoField["PUBLISHED_DATE"] = "published_date";
  JournalPublicationInfoField["ISSUE"] = "issue";
  JournalPublicationInfoField["DAY"] = "dat";
  JournalPublicationInfoField["MONTH"] = "month";
  JournalPublicationInfoField["YEAR"] = "year";
})(JournalPublicationInfoField || (JournalPublicationInfoField = {}));
export var MailingListPublicationInfoField;
(function (MailingListPublicationInfoField) {
  MailingListPublicationInfoField["PUBLISHER"] = "inst";
  MailingListPublicationInfoField["TITLE"] = "title";
  MailingListPublicationInfoField["URL"] = "url";
  MailingListPublicationInfoField["ELEC_PUB_DATE"] = "electronically_published_date";
  MailingListPublicationInfoField["DATE_ACCESSED"] = "date_accessed";
})(MailingListPublicationInfoField || (MailingListPublicationInfoField = {}));
export var OnlineDatabaseField;
(function (OnlineDatabaseField) {
  OnlineDatabaseField["CITY"] = "city";
  OnlineDatabaseField["DATABASE"] = "db";
  OnlineDatabaseField["DISPLAY_URL"] = "showurl";
  OnlineDatabaseField["LIBRARY"] = "library";
  OnlineDatabaseField["SERVICE"] = "service";
  OnlineDatabaseField["VERSION"] = "version";
  OnlineDatabaseField["SEARCH_TYPE"] = "searchtype";
  OnlineDatabaseField["SEARCH_TEXT"] = "searchtext";
  OnlineDatabaseField["DATE_ACCESSED"] = "date_accessed";
  OnlineDatabaseField["ELEC_PUB_DATE"] = "electronically_published_date";
})(OnlineDatabaseField || (OnlineDatabaseField = {}));
export var DigitalFilePublicationInfoField;
(function (DigitalFilePublicationInfoField) {
  DigitalFilePublicationInfoField["ORG"] = "org";
  DigitalFilePublicationInfoField["CITY"] = "city";
  DigitalFilePublicationInfoField["DATE_PUBLISHED"] = "date-published";
})(DigitalFilePublicationInfoField || (DigitalFilePublicationInfoField = {}));
export var WebsitePublicationField;
(function (WebsitePublicationField) {
  WebsitePublicationField["DISPLAY_URL"] = "showurl";
  WebsitePublicationField["PUBLISHER"] = "inst";
  WebsitePublicationField["TITLE"] = "title";
  WebsitePublicationField["URL"] = "url";
  WebsitePublicationField["VERSION"] = "version";
  WebsitePublicationField["ELEC_PUB_DATE"] = "electronically_published_date";
  WebsitePublicationField["DATE_ACCESSED"] = "date_accessed";
})(WebsitePublicationField || (WebsitePublicationField = {}));
export var MagazineNewspaperPublicationField;
(function (MagazineNewspaperPublicationField) {
  MagazineNewspaperPublicationField["TITLE"] = "title";
  MagazineNewspaperPublicationField["CITY"] = "city";
  MagazineNewspaperPublicationField["EDITION"] = "edition";
  MagazineNewspaperPublicationField["SECTION"] = "section";
  MagazineNewspaperPublicationField["PUBLISHED_DATE"] = "published_date";
  MagazineNewspaperPublicationField["START_PAGE"] = "start";
  MagazineNewspaperPublicationField["END_PAGE"] = "end";
  MagazineNewspaperPublicationField["VOLUME"] = "vol";
  MagazineNewspaperPublicationField["ISSUE"] = "issue";
  MagazineNewspaperPublicationField["NON_CONSECUTIVE"] = "nonconsecutive";
})(MagazineNewspaperPublicationField || (MagazineNewspaperPublicationField = {}));
export var livePublicationField;
(function (livePublicationField) {
  livePublicationField["CITY"] = "city";
  livePublicationField["DATE_VIEWED"] = "date_viewed";
  livePublicationField["LOCATION"] = "location";
  livePublicationField["TITLE"] = "title";
})(livePublicationField || (livePublicationField = {}));
export var FilmPublicationField;
(function (FilmPublicationField) {
  FilmPublicationField["COUNTRY"] = "country";
  FilmPublicationField["DISTRIBUTOR"] = "distributor";
  FilmPublicationField["MEDIA_TYPE"] = "mediatype";
  FilmPublicationField["MEDIA_TYPE_OTHER"] = "mediatypeother";
  FilmPublicationField["YEAR"] = "year";
})(FilmPublicationField || (FilmPublicationField = {}));
export var TvRadioField;
(function (TvRadioField) {
  TvRadioField["TRANSCRIPT"] = "transcript";
  TvRadioField["CALL"] = "call";
  TvRadioField["CITY"] = "city";
  TvRadioField["MEDIUM"] = "medium";
  TvRadioField["NETWORK"] = "network";
  TvRadioField["STATE"] = "state";
  TvRadioField["TITLE"] = "title";
  TvRadioField["DATE"] = "date";
})(TvRadioField || (TvRadioField = {}));
export var FieldType;
(function (FieldType) {
  FieldType[FieldType["CHECKBOX"] = 0] = "CHECKBOX";
  FieldType[FieldType["LABEL"] = 1] = "LABEL";
  FieldType[FieldType["PUBDATE"] = 2] = "PUBDATE";
  FieldType[FieldType["RADIO"] = 3] = "RADIO";
  FieldType[FieldType["RADIO_GROUP_WITH_INPUT"] = 4] = "RADIO_GROUP_WITH_INPUT";
  FieldType[FieldType["TEXT"] = 5] = "TEXT";
  FieldType[FieldType["CHECKBOX_WITH_LABEL"] = 6] = "CHECKBOX_WITH_LABEL";
})(FieldType || (FieldType = {}));
export var PubOtherField;
(function (PubOtherField) {
  PubOtherField["LOCATION"] = "location";
  PubOtherField["MEDIUM"] = "medium";
  PubOtherField["STATE"] = "state";
  PubOtherField["CITY"] = "city";
  PubOtherField["YEAR"] = "year";
  PubOtherField["DAY"] = "dat";
  PubOtherField["MONTH"] = "month";
  PubOtherField["PUBLISHED_DATE"] = "published_date";
  PubOtherField["TITLE"] = "title";
  PubOtherField["ORGANISATION"] = "org";
})(PubOtherField || (PubOtherField = {}));
export var MediaPublicationInfoField;
(function (MediaPublicationInfoField) {
  MediaPublicationInfoField["TYPE"] = "type";
  MediaPublicationInfoField["MEDIUM"] = "medium";
  MediaPublicationInfoField["PUBLISHER"] = "publisher";
  MediaPublicationInfoField["PUBLISHER_LOCATION"] = "publisherlocation";
})(MediaPublicationInfoField || (MediaPublicationInfoField = {}));
export var CommonSearchTypeOptions = {
  KEYWORD: {
    key: 'keyword',
    value: 'Keyword',
    placeholderText: 'Type keyword here'
  },
  PATH: {
    key: 'path',
    value: 'Path',
    placeholderText: 'Ex: Science; Biology; Birds'
  },
  URL: {
    key: 'url',
    value: 'URL',
    placeholderText: 'http://'
  }
};